import styled from 'styled-components';

import { RadioButton } from '@telialt/common-radio-button/src';
import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';
import { Tooltip } from '@telialt/common-tooltip/src/Tooltip';

export const LeasingPlanSelectorWrapper = styled.section`
    margin: 0;
    border-top: 1px solid ${getPurpurColor('gray200')};
    padding-top: ${getPurpurSpacing('600')};
    padding-bottom: ${getPurpurSpacing('600')};
    position: relative;
`;

export const RowOrderSwapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('300')};
    row-gap: ${getPurpurSpacing('300')};
`;

export const Radio = styled(RadioButton)`
    grid-column: 1;
    grid-row: 1;
`;

export const LabelDiscountPrice = styled.div`
    grid-column: 1;
    grid-row: 2;
    color: ${getPurpurColor('red600')};
    font-size: ${getPurpurTypography('scale75')};
    margin-left: 2.25rem;
`;

export const LabelMonthlyPrice = styled.div`
    grid-column: 2;
    grid-row: 1;
    font-size: 1rem;
    font-weight: bold;
    justify-self: right;
    text-align: right;
`;

export const LabelDiscountTotalPrice = styled.div`
    grid-column: 2;
    grid-row: 2;
    font-size: ${getPurpurTypography('scale75')};
    justify-self: right;
`;

const RadioOptionWrapper = styled.div`
    display: grid;
    grid-template-columns: 0.6fr 0.4fr;
    grid-auto-rows: ${getPurpurSpacing('300')} auto;
    column-gap: ${getPurpurSpacing('200')};
`;

export const TooltipWithRestrictionMessage = styled(Tooltip)`
    grid-column: 1;
    grid-row: 1;
    z-index: 2;
    cursor: not-allowed;
    width: 70%;
`;

export const LeasingRadioOptionWrapper = styled(RadioOptionWrapper)``;

export const FullPriceRadioOptionWrapper = styled(RadioOptionWrapper)`
    margin-top: ${getPurpurSpacing('300')};
`;
